module.exports = __webpack_public_path__ + "static/media/ipul-1.0995b886.jpg";